import { render } from "./DemoOverlay.vue?vue&type=template&id=687c092a&scoped=true"
import script from "./DemoOverlay.vue?vue&type=script&lang=js"
export * from "./DemoOverlay.vue?vue&type=script&lang=js"

import "./DemoOverlay.vue?vue&type=style&index=0&id=687c092a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687c092a"]])

export default __exports__